import { accessPending } from '@/domain/enums/login';

const AnswerSecretQuestion = () => import(/* webpackChunkName: "answerSecretQuestion" */ '../forgotPassword/AnswerSecretQuestion');
const External = () => import(/* webpackChunkName: "external" */ '../external/External.vue');
const ForgotPassword = () => import(/* webpackChunkName: "forgotPassword" */ '../forgotPassword/ForgotPassword');
const InsertUserData = () => import(/* webpackChunkName: "insertUserData" */ '../forgotPassword/InsertUserData');
const Login = () => import(/* webpackChunkName: "login" */ '../Login');
const Register = () => import(/* webpackChunkName: "register" */ '../register/Register');
const RegisterSecretQuestion = () => import(/* webpackChunkName: "registerSecretQuestion" */ '../register/RegisterSecretQuestion');
const RetrieveOptions = () => import(/* webpackChunkName: "retrieveOptions" */ '../forgotPassword/RetrieveOptions');
const SignIn = () => import(/* webpackChunkName: "signIn" */ '../signIn/SignIn');
const SoftwareLicense = () => import(/* webpackChunkName: "loginSoftwareLicense" */ '../softwareLicense/SoftwareLicense');
const SoftwareLicenseConfirmation = () => import(/* webpackChunkName: "softwareLicenseConfirmation" */ '../softwareLicense/SoftwareLicenseConfirmation');
const SoftwareLicenseText = () => import(/* webpackChunkName: "softwareLicenseText" */ '../softwareLicense/SoftwareLicenseText');
const TemporaryAccess = () => import(/* webpackChunkName: "temporaryAccess" */ '../register/TemporaryAccess');
const TemporaryPassword = () => import(/* webpackChunkName: "temporaryPassword" */ '../forgotPassword/TemporaryPassword');
const TemporaryPasswordSent = () => import(/* webpackChunkName: "temporaryPasswordSent" */ '../forgotPassword/TemporaryPasswordSent');

export default {
  path: '/login',
  component: Login,
  children: [
    {
      path: '',
      name: 'sign-in',
      component: SignIn,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: 'externo',
      name: 'externo',
      component: External,
      meta: {
        allowAnonymous: true,
      },
    },
    {
      path: 'esqueceu-senha',
      component: ForgotPassword,
      children: [
        {
          path: '',
          name: 'insert-user-data',
          component: InsertUserData,
          meta: {
            allowAnonymous: true,
          },
        },
        {
          path: 'opcoes-recuperacao',
          name: 'retrieve-options',
          component: RetrieveOptions,
          meta: {
            allowAnonymous: true,
          },
        },
        {
          path: 'responder-pergunta-secreta',
          name: 'answer-secret-question',
          component: AnswerSecretQuestion,
          meta: {
            allowAnonymous: true,
          },
        },
        {
          path: 'senha-temporaria',
          name: 'temporary-password',
          component: TemporaryPassword,
          meta: {
            allowAnonymous: true,
          },
        },
        {
          path: 'senha-temporaria-enviada',
          name: 'temporary-password-sent',
          component: TemporaryPasswordSent,
          meta: {
            allowAnonymous: true,
          },
        },
      ],
    },
    {
      path: 'cadastro',
      component: Register,
      children: [
        {
          path: 'acesso-temporario',
          name: 'temporary-access',
          component: TemporaryAccess,
          meta: {
            allowAccessPending: [accessPending.TEMP_ACCESS, accessPending.LICENSE],
          },
        },
        {
          path: 'pergunta-secreta',
          name: 'register-secret-question',
          component: RegisterSecretQuestion,
          meta: {
            allowAccessPending: [accessPending.TEMP_ACCESS, accessPending.LICENSE],
          },
        },
      ],
    },
    {
      path: 'licenca-software',
      component: SoftwareLicense,
      children: [
        {
          path: '',
          name: 'software-license-text',
          component: SoftwareLicenseText,
          meta: {
            allowAccessPending: accessPending.LICENSE,
          },
        },
        {
          path: 'confirmacao',
          name: 'software-license-confirmation',
          component: SoftwareLicenseConfirmation,
          meta: {
            allowAccessPending: accessPending.LICENSE,
          },
        },
      ],
    },
  ],
};
